import { encode, decode } from "./base64-arraybuffer";
import { isMobile } from "react-device-detect";

export const checkIsWebAuthnSupported = async () => {
  if (isMobile && window.PublicKeyCredential) {
    try {
      await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
      return { isAuthenticator: 1 };
    } catch {
      return { isAuthenticator: 0 };
    }
  }
  return { isAuthenticator: 0 };
};

export const formatCredentialOptions = (credentials) => {
  credentials.challenge = decode(credentials.challenge);
  credentials.user = {
    id: decode(credentials.user.id),
    displayName: credentials.user.displayName,
    name: credentials.user.name,
  };
  credentials.rp = { id: credentials.rp.id, name: credentials.rp.name };

  return credentials;
};

export const formatCredentials = (credentials) => {
  if (credentials instanceof Array) {
    let arr = [];
    for (let i of credentials) arr.push(formatCredentials(i));

    return arr;
  } else if (credentials instanceof ArrayBuffer) {
    return encode(credentials);
  } else if (credentials instanceof Object) {
    let obj = {};

    for (let key in credentials) {
      obj[key] = formatCredentials(credentials[key]);
    }

    return obj;
  }

  return credentials;
};
